import { RecaptchaInput } from '#/components/RecaptchaInput/RecaptchaInput';
import { useAppConfig } from '#/config/AppConfigContext';

import { CheckboxField } from './CheckboxField';
import { Field } from './Field/Field';

export function RecaptchaField() {
  const { appConfig } = useAppConfig();

  if (!appConfig.google.recaptcha.enabled) {
    return (
      <CheckboxField
        name="gRecaptchaResponse"
        label="I'm not a robot"
        valueToChecked={{ recaptcha_mock: true, nope: false }}
      />
    );
  }

  return (
    <Field
      name="gRecaptchaResponse"
      renderInput={({ values, updateValue }) => (
        <RecaptchaInput
          // TODO: Fix this the next time the file is edited.
          // oxlint-disable-next-line @typescript-eslint/no-unsafe-assignment
          key={values.recaptchaKey}
          onChange={(gRecaptchaResponse) => {
            updateValue(gRecaptchaResponse);
          }}
        />
      )}
    />
  );
}
